import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import "../../css/addproperty.css";
import "../../css/addroomdetails.css";
import "../../css/styles.css";
import chennaipincode from "../../assets/pincode.json";
import { data, useNavigate } from "react-router-dom";
import {
  MapContainer,
  TileLayer,
  Marker,
  Popup,
  useMapEvents,
} from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import markerIconPng from "leaflet/dist/images/marker-icon.png";
import markerShadowPng from "leaflet/dist/images/marker-shadow.png";
import { useLocation } from "react-router-dom";
import Dashboard from "./Dashboard";

const customIcon = new L.Icon({
  iconUrl: markerIconPng,
  shadowUrl: markerShadowPng,
  iconSize: [25, 41],
  iconAnchor: [12, 41],
});

const LocationSelector = ({ setPosition, setAddress }) => {
  useMapEvents({
    click: async (e) => {
      const { lat, lng } = e.latlng;
      setPosition([lat, lng]);

      // Fetch address using reverse geocoding
      try {
        const response = await fetch(
          `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lng}`
        );
        const data = await response.json();
        if (data.display_name) {
          setAddress(data.display_name);
        } else {
          setAddress("Address not found");
        }
      } catch (error) {
        console.error("Error fetching address:", error);
      }
    },
  });

  return null;
};

const steps = [
  { id: 1, label: "Property Details" },
  { id: 2, label: "Photes" },
  { id: 3, label: "Address" },
];

const AddPropertyResidentialResell = ({ agent_id, agent_name }) => {
  const location = useLocation();
  const existingProperty = location.state?.property || null; // 🟢 Get the property data if available

  const [currentStep, setCurrentStep] = useState(1);
  const [showAdditionalDetails, setShowAdditionalDetails] = useState(false);
  const pincodeData = chennaipincode;
  const [step, setStep] = useState(1);
  const [pincode, setPincode] = useState("");
  const [propertyType, setPropertyType] = useState("Residential");
  const [lookingTo, setLookingTo] = useState("Resale");
  const [searchTerm, setSearchTerm] = useState("");
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [selectedPincode, setSelectedPincode] = useState("");
  const [localities, setLocalities] = useState([]);
  const [selectedLocality, setSelectedLocality] = useState("");
  const [locality, setLocality] = useState("");
  const [building, setBuilding] = useState("");
  const [selectedPropertyType, setSelectedPropertyType] = useState("");
  const [plotprice, setPlotPrice] = useState("");
  const [possessiondate, setPossessionDate] = useState("");
  const [ageofproperty, setAgeOfProperty] = useState(""); // Define state for age of property
  const [coveredParking, setCoveredParking] = useState("");
  const [openParking, setOpenParking] = useState("");
  const [cost, setCost] = useState("");
  const [maintenanceCharges, setMaintenanceCharges] = useState("");
  const [brokerage, setBrokerage] = useState("");
  const [bropercentage, setBropercentage] = useState("");
  const [furnishType, setFurnishType] = useState("");
  const [builtUpArea, setBuiltUpArea] = useState("");
  const [landArea,setLandArea] = useState("");
  const [uds,setUds] = useState("");
  const [transactionType, setTransactionType] = useState("");
  const [constructionStatus, setConstructionStatus] = useState("");
  const [bathrooms, setBathrooms] = useState("");
  const [balconies, setBalconies] = useState("");
  const [carpetArea, setCarpetArea] = useState("");
  const [floorNo, setFloorNo] = useState("");
  const [totalFloors, setTotalFloors] = useState("");
  const [facing, setFacing] = useState("");
  const [servantRoom, setServantRoom] = useState("");
  const [posessionStatus, setPosessionStatus] = useState("");
  const [plotArea, setPlotArea] = useState("");
  const [areaUnit, setAreaUnit] = useState("");
  const [length, setLength] = useState("");
  const [width, setWidth] = useState("");
  const [facingRoadWidth, setFacingRoadWidth] = useState("");
  const [cornerProperty, setCornerProperty] = useState("");
  const [constructionStarted, setConstructionStarted] = useState("");
  const [facingDirection, setFacingDirection] = useState("");
  const [boundaryWall, setBoundaryWall] = useState("");
  const [openSides, setOpenSides] = useState("");
  const [floorsAllowed, setFloorsAllowed] = useState("");
  const [reraId, setReraId] = useState("");
  const [propertyDescription, setPropertyDescription] = useState("");
  const [Address, setAddress] = useState("");
  const [selectedFurnishings, setSelectedFurnishings] = useState([]);
  const [selectedAmenities, setSelectedAmenities] = useState([]);
  const [images, setImages] = useState([]);
  const [videos, setVideos] = useState([]);
  const [bhkType, setBhkType] = useState("");
  const [position, setPosition] = useState([12.9716, 77.5946]); // Default Lat/Lng for Velachery
  const [paraaddress, setParaAddress] = useState("");
  const [errors, setErrors] = useState({});
  const [removedImages, setRemovedImages] = useState([]);

  const [formData, setFormData] = useState({
    proptype: "Residential",
    lookingto: "Resale",
    locality: "",
    city: "Chennai",
    pincode: "",
    pinlocality: "",
    resiproptype: "",
    builtUpArea: "",
    ageofproperty: "",
    bathroom: "",
    balcony: "",
    images: [],
    videos: [],
  });

  const handleImageUpload = (event) => {
    const files = Array.from(event.target.files);
    setImages((prevImages) => [
      ...prevImages, // Keep previous images (DB URLs)
      ...files, // Add new files
    ]);
  };

  const handleVideoUpload = (event) => {
    const files = Array.from(event.target.files);
    setVideos([...videos, ...files]);
  };
  // Remove Image
  const removeImage = (index) => {
  setImages((prev) => {
    const removed = prev[index];
    if (typeof removed === "string") {
      // Only push if it's a DB image (not newly uploaded file)
      setRemovedImages((prevRemoved) => [...prevRemoved, removed]);
    }
    return prev.filter((_, i) => i !== index);
  });
};

  // Remove Video
  const removeVideo = (index) => {
    setVideos((prev) => prev.filter((_, i) => i !== index));
  };

  const imagePreviews = images.map((file) => {
    if (typeof file === "string") {
      // If it's already a URL (from DB), use it directly
      return file;
    } else if (file instanceof File) {
      // If it's a File object, create an object URL
      return URL.createObjectURL(file);
    } else {
      console.error("Invalid file data:", file);
      return null;
    }
  });

  useEffect(() => {
    if (existingProperty) {
      console.log("✏️ Editing Property:", existingProperty);
      setPropertyType(existingProperty.proptype || "Residential");
      setLookingTo(existingProperty.lookingto || "Resale");
      setBuilding(existingProperty.bpn || "");
      setLocality(existingProperty.city || "Chennai");
      setSelectedPincode(existingProperty.pincode || "");
      setSelectedLocality(existingProperty.pinlocality || "");
      setSelectedPropertyType(existingProperty.proptypename || "");
      setBhkType(existingProperty.bhk || "");
      setBuiltUpArea(existingProperty.buitupareasq || "");
      setLandArea(existingProperty.landarea || "");
      setUds(existingProperty.uds || "");
      setAgeOfProperty(existingProperty.ageofproperty || "");
      setBathrooms(existingProperty.bathroom ? Number(existingProperty.bathroom) : "");
      setBalconies(existingProperty.balcony ? Number(existingProperty.balcony) : "");
      setFurnishType(existingProperty.furnishtype || "");
      setPropertyDescription(existingProperty.propertydes || "");
      setMaintenanceCharges(existingProperty.maintenancecharge || "");
      setBrokerage(existingProperty.brokeragcharge?.toLowerCase() === "yes" ? "Yes" : "No");
      setBropercentage(existingProperty.bropercentage || "");
      setCarpetArea(existingProperty.carpetarea || "");
      setFloorNo(existingProperty.floorno || "");
      setTotalFloors(existingProperty.totalfloor || "");
      setPosessionStatus(existingProperty.PosessionStatus || "");
      setPlotPrice(existingProperty.plotprice || "");
      setPossessionDate(existingProperty.possessiondate || "");
      setReraId(existingProperty.reraid || "");
      setBoundaryWall(existingProperty.boundarywall || "");
      setOpenSides(existingProperty.opensides || "");
      setFloorsAllowed(existingProperty.floorsallowed || "");
      setPlotArea(existingProperty.plotarea || "");
      setAreaUnit(existingProperty.areaunit || "");
      setLength(existingProperty.lenght || "");
      setWidth(existingProperty.width || "");
      setFacingRoadWidth(existingProperty.widthoffacingroad || "");
      setCornerProperty(existingProperty.cornerproperty || "");
      setConstructionStarted(existingProperty.constructionstarted || "");
      setCoveredParking(
        existingProperty.coveredparking
          ? Number(existingProperty.coveredparking)
          : ""
      );
      setOpenParking(
        existingProperty.openparking ? Number(existingProperty.openparking) : ""
      );
      setCost(existingProperty.cost || "");
      setFacing(existingProperty.facing || "");
      setAddress(existingProperty.addressaddlocality || "");

      setTransactionType(existingProperty.transactiontype || "");
      setConstructionStatus(existingProperty.constructionstatus || "");
      setServantRoom(existingProperty.servantroom || "");

      setSelectedFurnishings(
        existingProperty.flatfurnishings
          ? existingProperty.flatfurnishings
              .split(",")
              .map((item) => item.trim())
          : []
      );
      setSelectedAmenities(
        existingProperty.societyamenities
          ? existingProperty.societyamenities
              .split(",")
              .map((item) => item.trim())
          : []
      );

      setImages(
        existingProperty.images?.map((img) =>
          typeof img === "string" ? img : null
        ) || []
      );
      setVideos(existingProperty.videos || []);
    }
  }, [existingProperty]);

  useEffect(() => {
    console.log("Updated balcony:", formData.balcony);
    console.log("Updated bathroom:", formData.bathroom);
  }, [formData]);

  const handleChange = (key, value) => {
    if (key === "availableFrom") {
      setPossessionDate(value);
    }
  };
  useEffect(() => {
    const fetchCoordinates = async () => {
      if (!selectedLocality.trim()) return;
      try {
        const response = await fetch(
          `https://nominatim.openstreetmap.org/search?format=json&q=${selectedLocality}, Chennai`
        );
        const data = await response.json();
        if (data.length > 0) {
          const lat = parseFloat(data[0].lat);
          const lon = parseFloat(data[0].lon);
          setPosition([lat, lon]);
          setAddress(data[0].display_name);
        } else {
          setAddress("Location not found");
        }
      } catch (error) {
        console.error("Error fetching coordinates:", error);
      }
    };

    if (locality) {
      fetchCoordinates();
    }
  }, [locality]);

  const wrapperRef = useRef(null);
  const navigate = useNavigate();

  const handleLookingToClick = (option) => {
    setLookingTo(option);

    // Redirect based on selection
    if (propertyType === "Residential" && option === "Rent") {
      navigate("/residential-rent");
    } else if (propertyType === "Residential" && option === "Resale") {
      navigate("/residential-resell");
    } else if (propertyType === "Residential" && option === "PG/Co-living") {
      navigate("/pg-co-living");
    } else if (propertyType === "Commercial" && option === "Rent") {
      navigate("/Commercial-rent");
    } else if (propertyType === "Commercial" && option === "Resale") {
      navigate("/Commercial-resale");
    }
  };

  const furnishings = [
    "Dining Table",
    "Washing Machine",
    "Sofa",
    "Microwave",
    "Stove",
    "Fridge",
    "Water Purifier",
    "Gas Pipeline",
    "AC",
    "Bed",
    "TV",
    "Cupboard",
    "Geyser",
  ];

  const amenities = [
    "Lift",
    "CCTV",
    "Gym",
    "Garden",
    "Kids Area",
    "Sports",
    "Swimming Pool",
    "Intercom",
    "Gated Community",
    "Club House",
    "Community Hall",
    "Regular Water Supply",
    "Power Backup",
    "Pet Allowed",
  ];

  // Toggle Selection
  const toggleSelection = (item, selectedList, setSelectedList) => {
    setSelectedList(
      selectedList.includes(item)
        ? selectedList.filter((i) => i !== item)
        : [...selectedList, item]
    );
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setShowSuggestions(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Filter pincode suggestions based on the search term
  const filteredPincodes = pincodeData.filter((item) =>
    item.pincode.includes(searchTerm)
  );

  // Handle changes in the pincode input field
  const handleInputChange = (e) => {
    setSearchTerm(e.target.value);
    setShowSuggestions(true);
    if (!e.target.value) setShowSuggestions(false);
  };

  // Handle selecting a pincode from suggestions
  const handleSelect = (pincode) => {
    setSelectedPincode(pincode);
    const selected = pincodeData.find((item) => item.pincode === pincode);
    setLocalities(selected ? selected.locality : []);
    setShowSuggestions(false);
    setErrors({ ...errors, pincode: "" });
  };

  // Handle selecting a locality
  const handleLocalityChange = (event) => {
    setSelectedLocality(event.target.value);
    setErrors({ ...errors, selectedLocality: "" });
  };

  const propertyTypes = [
    "Apartment",
    "Independent Floor",
    "Independent House",
    "Villa",
    "Plot",
    "Penthouse",
    "Duplex",
    "Studio",
    "Agricultural",
  ];

  const bhkOptions = [
    "1 RK",
    "1 BHK",
    "1.5 BHK",
    "2 BHK",
    "2.5 BHK",
    "3 BHK",
    "3.5 BHK",
    "4 BHK",
    "4.5 BHK",
    "5 BHK",
    "5+ BHK",
  ];

  const validateForm = () => {
    let newErrors = {};

    // Step 1: Property Details Validation
    if (currentStep === 1) {
      if (!propertyType) newErrors.propertyType = "Please select a property type.";
      if (!building) newErrors.building = "Please enter Building Details";
      if (!locality) newErrors.locality = "Please enter your city";
      if (!selectedPincode) newErrors.pincode = "Please enter the pincode";
      if (!selectedPropertyType) newErrors.selectedPropertyType = "Please select Property type";
      if (!selectedLocality.trim()) newErrors.selectedLocality = "Locality is required.";
      if (selectedPropertyType === "Apartment") {
      if (!builtUpArea) newErrors.builtUpArea = "Built-up area is required.";
      if (!transactionType) newErrors.transactionType = "Transaction type is required.";
      if (!constructionStatus) newErrors.constructionStatus = "Construction status is required.";
      if (!bathrooms) newErrors.bathrooms = "Bathroom count is required.";
      if (balconies === null || balconies === undefined) {newErrors.balconies = "Balcony count is required.";}
      if (!cost) newErrors.cost = "Cost is required.";
      if (coveredParking === null || coveredParking === undefined) {newErrors.coveredParking = "Please enter the covered parking";}
      if (openParking === null || openParking === undefined) {newErrors.openParking = "Please enter open parking";}
      if (!cost) newErrors.cost = "Please enter the cost";
      if (!maintenanceCharges) newErrors.maintenanceCharges = "Please enter maintenance charge";
      if (!brokerage) newErrors.brokerage = "Please enter brokerage";
      if (!carpetArea) newErrors.carpetArea = "Please enter area in sq.ft.";
      if (!floorNo) newErrors.floorNo = "Please enter floor No";
      if (!totalFloors) newErrors.totalFloors = "Please enter Total Floors No";
      if (!furnishType) newErrors.furnishType = "Furnish type is required.";
      }

      if (
        selectedPropertyType === "Plot" ||
        selectedPropertyType === "Agricultural"
      ) {
        if (!plotArea) newErrors.plotArea = "Plot area is required.";
        if (!areaUnit) newErrors.areaUnit = "Area unit is required.";
        if (!length) newErrors.length = "Length is required.";
        if (!width) newErrors.width = "Width is required.";
        if (!facingRoadWidth) newErrors.facingRoadWidth = "Facing road width is required.";
        if (!plotprice) newErrors.plotprice = "Plot price is required.";
        if (!posessionStatus) newErrors.posessionStatus = "Posession status is required.";
        
        if (posessionStatus === "Immediate") {
        if (!ageofproperty) newErrors.ageofproperty = "Age of property is required.";
        if (!possessiondate) newErrors.possessiondate = "Possession date is required.";
        }
      }

      if (
        selectedPropertyType === "Villa" ||
        selectedPropertyType === "Independent House" ||
        selectedPropertyType === "Penthouse" ||
        selectedPropertyType === "Duplex" ||
        selectedPropertyType === "Studio" ||
        selectedPropertyType === "Independent Floor"
      ) {
        if (!bhkType) newErrors.bhkType = "BHK type is required.";
        if (!builtUpArea) newErrors.builtUpArea = "Built-up area is required.";
        if (!constructionStatus) newErrors.constructionStatus = "Construction status is required.";
        if (!bathrooms) newErrors.bathrooms = "Bathroom count is required.";
        
        if (balconies === null || balconies === undefined) 
          {
          newErrors.balconies = "Balcony count is required.";
        }
        if (!furnishType) newErrors.furnishType = "Furnish type is required.";
        if (coveredParking === null || coveredParking === undefined) {
          newErrors.coveredParking = "Please enter the covered parking";
        }
        if (openParking === null || openParking === undefined) {
          newErrors.openParking = "Please enter open parking";
        }
        if (!cost) newErrors.cost = "Please enter the cost";
        if (!maintenanceCharges)
          newErrors.maintenanceCharges = "Please enter maintenance charge";
        if (!brokerage) newErrors.brokerage = "Please enter brokerage";
        if (!carpetArea) newErrors.carpetArea = "Please enter area in sq.ft.";
        if (!floorNo) newErrors.floorNo = "Floor number is required.";
        if (!totalFloors) newErrors.totalFloors = "Total floors are required.";
        if (!transactionType)
          newErrors.transactionType = "Transaction type is required.";
      }
    }



    // Step 3: Address Validation
    if (currentStep === 3) {
      if (!Address.trim()) newErrors.Address = "Address is required.";
    }

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const handleNextStep = () => {
    
      if (currentStep < steps.length) {
        setCurrentStep((prev) => prev + 1);
      }
    
  };

  const handlePrevStep = () => {
    if (currentStep > 1) {
      setCurrentStep((prev) => prev - 1);
    }
  };

  const getRefByKey = (key) => {
    const refs = {
      propertyType: propertyTypeRef,
      building: buildingRef,
      locality: localityRef,
      pincode: pincodeRef,
      selectedPropertyType: selectedPropertyTypeRef,
      builtUpArea: builtUpAreaRef,
      landArea:landAreaRef,
      transactionType: transactionTypeRef,
      constructionStatus: constructionStatusRef,
      bathrooms: bathroomRef,
      balconies: balconiesRef,
      coveredParking: coveredParkingRef,
      openParking: openParkingRef,
      cost: costRef,
      maintenanceCharges: maintenanceChargesRef,
      brokerage: brokerageRef,
      bropercentage: bropercentageRef,
      carpetArea: carpetAreaRef,
      floorNo: floorNoRef,
      totalFloors: totalFloorsRef,
      posessionStatus: posessionStatusRef,
      ageofproperty: ageofpropertyRef,
      plotprice: plotpriceRef,
      plotArea: plotAreaRef,
      areaUnit: areaUnitRef,
      length: lengthRef,
      width: widthRef,
      facingRoadWidth: facingRoadWidthRef,
    };
    return refs[key];
  };

  const propertyTypeRef = useRef(null);
  const buildingRef = useRef(null);
  const localityRef = useRef(null);
  const pincodeRef = useRef(null);
  const selectedPropertyTypeRef = useRef(null);
  const builtUpAreaRef = useRef(null);
  const landAreaRef = useRef(null);
  const transactionTypeRef = useRef(null);
  const constructionStatusRef = useRef(null);
  const bathroomRef = useRef(null);
  const balconiesRef = useRef(null);
  const coveredParkingRef = useRef(null);
  const openParkingRef = useRef(null);
  const costRef = useRef(null);
  const maintenanceChargesRef = useRef(null);
  const brokerageRef = useRef(null);
  const bropercentageRef = useRef(null);
  const carpetAreaRef = useRef(null);
  const floorNoRef = useRef(null);
  const totalFloorsRef = useRef(null);
  const posessionStatusRef = useRef(null);
  const ageofpropertyRef = useRef(null);
  const plotpriceRef = useRef(null);
  const plotAreaRef = useRef(null);
  const areaUnitRef = useRef(null);
  const lengthRef = useRef(null);
  const widthRef = useRef(null);
  const facingRoadWidthRef = useRef(null);

  const handleSubmit = async () => {
    
    const formData = new FormData();
    formData.append("proptype", propertyType);
    formData.append("lookingto", lookingTo);
    formData.append("bpn", building);
    formData.append("city", "Chennai");
    formData.append("pincode", selectedPincode);
    formData.append("pinlocality", selectedLocality);
    formData.append("resiproptype", selectedPropertyType);
    formData.append("buitupareasq", builtUpArea);
    formData.append("landarea", landArea);
    formData.append("uds", uds);
    formData.append("ageofproperty", ageofproperty); // Add age of property if applicable
    formData.append("bathroom", bathrooms);
    formData.append("balcony", balconies);
    formData.append("furnishtype", furnishType);
    formData.append("preferredtenanttype", ""); // Add preferred tenant type if applicable
    formData.append("propertydes", propertyDescription);
    formData.append("availablefrom", ""); // Add available from date if applicable
    formData.append("maintenancecharge", maintenanceCharges);
    formData.append("brokeragcharge", brokerage);
    formData.append("bropercentage", bropercentage);
    formData.append("carpetarea", carpetArea);
    formData.append("floorno", floorNo);
    formData.append("totalfloor", totalFloors);
    formData.append("PosessionStatus", posessionStatus);
    formData.append("plotprice", plotprice);
    formData.append("possessiondate", possessiondate);
    formData.append("reraid", reraId);
    formData.append("boundarywall", boundaryWall);
    formData.append("opensides", openSides);
    formData.append("floorsallowed", floorsAllowed);
    formData.append("plotarea", plotArea);
    formData.append("areaunit", areaUnit);
    formData.append("length", length);
    formData.append("width", width);
    formData.append("facingroadwidth", facingRoadWidth);
    formData.append("cornerproperty", cornerProperty);
    formData.append("constructionstarted", constructionStarted);
    formData.append("coveredParking", coveredParking);
    formData.append("openParking", openParking);
    formData.append("cost", cost);
    formData.append("facing", facing);
    formData.append("addressaddlocality", Address);
    formData.append("addmapp", paraaddress); // Add map address if applicable
    formData.append("transactiontype", transactionType);
    formData.append("constructionstatus", constructionStatus);
    formData.append("coveredparking", coveredParking);
    formData.append("openparking", openParking);
    formData.append("servantroom", servantRoom);
    formData.append("bhk", bhkType);

    formData.append("flatfurnishings", selectedFurnishings.join(", "));
    formData.append("societyamenities", selectedAmenities.join(", "));
    formData.append("agent_name", agent_name);
    formData.append("agent_id", agent_id);
    formData.append("fdt", new Date().toISOString());
    formData.append("status", "active");

     images.forEach((image) => {
    if (image instanceof File) {
      formData.append("images", image);
    }
  });


    videos.forEach((video, index) => {
      formData.append(`video`, video);
    });

  removedImages.forEach((imgUrl) => {
    formData.append("removeImages", imgUrl);
  });

    try {
      let response;
      if (existingProperty) {
        // 🟡 UPDATE PROPERTY (PUT Request)
        const proptype = formData.proptype || "Residential"; // Set default value if undefined
        const lookingto = formData.lookingto || "Resale"; // Set default value if undefined
        const id = existingProperty?.id;
        response = await axios.put(
          `/api/agent/update-property/${proptype}/${lookingto}/${existingProperty.id}`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        alert("Property Updated Successfully!");
  navigate("/listings");
      } else {
        // 🔵 ADD NEW PROPERTY (POST Request)
        response = await axios.post(
          "/api/add-property",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        alert("Property Added Successfully!");
        navigate("/listings"); // Redirect to agent dashboard after successful addition
      }

      console.log("✅ Response:", response.data);
    } catch (error) {
      console.error("❌ Error:", error.response?.data || error.message);
      alert("Something went wrong. Please try again.");
    }
  };

  return (
    <div>
      <Dashboard />
      <div className="postprop">
        {/* Sidebar */}
        <div className="sidebar">
          <h2>Post your property</h2>
          <p>
            Welcome! &nbsp; {agent_name} || {agent_id}{" "}
          </p>
          <p>ReSell or rent your property</p>

          <div className="timeline">
            {steps.map((step) => (
              <div
                key={step.id}
                className={`step ${
                  step.id < currentStep
                    ? "complete"
                    : step.id === currentStep
                    ? "active"
                    : ""
                }`}
              >
                <div className="circle">
                  {step.id < currentStep ? "✓" : step.id}
                </div>
                <div className="label">
                  <p>{step.label}</p>
                  <span>
                    {step.id < currentStep
                      ? "Completed"
                      : step.id === currentStep
                      ? "In progress"
                      : "Pending"}
                  </span>
                </div>
              </div>
            ))}
          </div>
          <span>need help: call +91 9585973683</span>
        </div>

        {/* Add PG/Co-living Properties */}
        <div className="form-section">
          <div className="form-container ">
            {currentStep === 1 && (
              <div>
                <h2 className="text-xl font-semibold mb-4">
                  <u>Add Property Details</u>
                </h2>

                {/* Property Type */}
                <div className="mb-4">
                  <p className="mb-2 font-medium">Property Type *</p>
                  <div className="button-group">
                    <button
                      className={`button ${
                        propertyType === "Residential" ? "selected" : ""
                      }`}
                      onClick={() => {
                        setPropertyType("Residential");
                        setErrors({ ...errors, propertyType: "" });
                      }}
                      required
                    >
                      Residential
                    </button>
                    <button
                      className={`button ${
                        propertyType === "Commercial" ? "selected" : ""
                      }`}
                      onClick={() => {
                        setPropertyType("Commercial");
                        setErrors({ ...errors, propertyType: "" });
                      }}
                      required
                    >
                      Commercial
                    </button>
                  </div>
                  {errors.propertyType && (
                    <span
                      style={{ color: "red", fontSize: "0.8rem" }}
                      className="text-sm"
                    >
                      {errors.propertyType}
                    </span>
                  )}
                </div>

                {/* Looking To */}
                <div className="mb-4">
                  <p className="mb-2 font-medium">Looking to *</p>
                  <div className="button-group">
                    {(propertyType === "Residential"
                      ? ["Rent", "Resale", "PG/Co-living"]
                      : ["Rent", "Resale"]
                    ).map((option) => (
                      <button
                        key={option}
                        className={`btnsmall ${
                          lookingTo === option ? "btnsmall-selected" : ""
                        }`}
                        onClick={() => {
                          handleLookingToClick(option);
                          setErrors({ ...errors, lookingTo: "" });
                        }}
                        required
                      >
                        {option}
                      </button>
                    ))}
                  </div>
                  {errors.lookingTo && (
                    <span
                      style={{ color: "red", fontSize: "0.8rem" }}
                      className="text-sm"
                    >
                      {errors.lookingTo}
                    </span>
                  )}
                </div>

                {/* Locality */}
                <div className="mb-4">
                  <label className="block mb-2 font-medium">Enter City *</label>
                  <input
                    type="text"
                    value={locality}
                    onChange={(e) => {
                      setLocality(e.target.value);
                      setErrors({ ...errors, locality: "" });
                    }}
                    className={`w-full border p-2 rounded-lg ${
                      errors.locality ? "border-red-500" : ""
                    }`}
                    placeholder="Enter City"
                    required
                  />
                  {errors.locality && (
                    <span
                      style={{ color: "red", fontSize: "0.8rem" }}
                      className="text-sm"
                    >
                      {" "}
                      {/* Adjusted error span */}
                      {errors.locality}
                    </span>
                  )}
                </div>

                {/* Building Details */}
                <div className="mb-4" ref={buildingRef}>
                  <label className="block mb-2 font-medium">
                    Building Details *
                  </label>
                  <input
                    type="text"
                    value={building}
                    onChange={(e) => {
                      setBuilding(e.target.value);
                      setErrors({ ...errors, building: "" });
                    }}
                    className="w-full border p-2 rounded-lg"
                    placeholder="Building/Project/Society"
                    required
                  />
                  {errors.building && (
                    <span
                      style={{ color: "red", fontSize: "0.8rem" }}
                      className="text-sm"
                    >
                      {errors.building}
                    </span>
                  )}
                </div>

                {/* Enter Pincode */}
                <div className="mb-4">
                  <label className="block mb-2 font-medium" htmlFor="pincode">
                    Enter Pincode *
                  </label>
                  <input
                    type="number"
                    id="pincode"
                    className="w-full border p-2 rounded-lg"
                    value={selectedPincode || searchTerm}
                    onChange={handleInputChange}
                    placeholder="Type pincode"
                    autoComplete="off"
                    required
                    inputMode="numeric"
                    maxLength={6} // Stops extra input
                  />
                  {errors.pincode && (
                    <span
                      style={{ color: "red", fontSize: "0.8rem" }}
                      className="text-sm"
                    >
                      {errors.pincode}
                    </span>
                  )}
                </div>

                {/* Suggestions dropdown for pincode */}
                {showSuggestions && (
                  <div className="suggestions-dropdown shadow-sm mb-4">
                    {filteredPincodes.length > 0 ? (
                      filteredPincodes.map((item) => (
                        <div
                          key={item.pincode}
                          className="suggestion-item"
                          onClick={() => {
                            handleSelect(item.pincode);
                            setErrors({ ...errors, pincode: "" });
                          }}
                        >
                          <div className="pincode">{item.pincode}</div>
                          <div className="area">{item.area}</div>
                        </div>
                      ))
                    ) : (
                      <div className="no-results">No pincodes found</div>
                    )}
                  </div>
                )}

                {/* After selecting pincode, show locality dropdown */}
                {selectedPincode && (
                  <>
                    <div className="mb-4">
                      <label
                        className="block mb-2 font-medium"
                        htmlFor="locality"
                      >
                        Select Locality:
                      </label>
                      <select
                        id="locality"
                        value={selectedLocality}
                        onChange={handleLocalityChange}
                        className="w-full border p-2 rounded-lg"
                      >
                        <option value="">Select a locality</option>
                        {localities.map((locality, index) => (
                          <option key={index} value={locality}>
                            {locality}
                          </option>
                        ))}
                      </select>
                    </div>
                    {errors.selectedLocality && (
                      <span
                        style={{ color: "red", fontSize: "0.8rem" }}
                        className="text-sm"
                      >
                        {errors.selectedLocality}
                      </span>
                    )}
                  </>
                )}

                {/* Property Type Selection */}
                <div className="mb-4">
                  <label className="block mb-2 font-medium">
                    Property Type *
                  </label>
                  <div className="button-group">
                    {propertyTypes.map((type) => (
                      <button
                        key={type}
                        type="button"
                        className={`grid-item ${
                          selectedPropertyType === type ? "active" : ""
                        }`}
                        onClick={() => {
                          setSelectedPropertyType(type);
                          setErrors({ ...errors, selectedPropertyType: "" });
                        }}
                        required
                      >
                        {type}
                      </button>
                    ))}
                  </div>
                  {errors.selectedPropertyType && (
                    <span
                      style={{ color: "red", fontSize: "0.8rem" }}
                      className="text-sm"
                    >
                      {errors.selectedPropertyType}
                    </span>
                  )}
                </div>

                {/* Additional Details for Apartments */}
                {selectedPropertyType === "Apartment" && (
                  <>
                    <div className="mb-4">
                      <label className="block mb-2 font-medium">BHK *</label>
                      <div className="button-group bhkwidth">
                        {bhkOptions.map((status) => (
                          <button
                            key={status}
                            className={`grid-item ${
                              bhkType === status ? "active" : " "
                            }`}
                            onClick={() => {
                              setBhkType(status);
                              setErrors({ ...errors, bhkType: "" });
                            }}
                          >
                            {status}
                          </button>
                        ))}
                      </div>
                      {errors.bhkType && (
                        <span
                          style={{ color: "red", fontSize: "0.8rem" }}
                          className="text-sm"
                        >
                          {errors.bhkType}
                        </span>
                      )}
                    </div>
                    {/* Built-Up Area */}
                    <div className="mb-4">
                      <label className="block mb-2 font-medium">
                        Built Up Area *
                      </label>
                      <input
                        type="text"
                        value={builtUpArea}
                        onChange={(e) => {
                          setBuiltUpArea(e.target.value);
                          setErrors({ ...errors, builtUpArea: "" });
                        }}
                        className="w-full p-2 border rounded-lg"
                        placeholder="Enter built-up area in sq. ft."
                        required
                        min="1"
                      />
                      {errors.builtUpArea && (
                        <span
                          style={{ color: "red", fontSize: "0.8rem" }}
                          className="text-sm"
                        >
                          {errors.builtUpArea}
                        </span>
                      )}
                    </div>

                    {/* Transaction Type */}
                    <div className="mb-4">
                      <label className="block mb-2 font-medium">
                        Transaction Type *
                      </label>
                      <div className="button-group">
                        {["New Booking", "Resale"].map((type) => (
                          <button
                            key={type}
                            type="button"
                            className={`grid-item ${
                              transactionType === type ? "active" : ""
                            }`}
                            onClick={() => {
                              setTransactionType(type);
                              setErrors({ ...errors, transactionType: "" });
                            }}
                            required
                          >
                            {type}
                          </button>
                        ))}
                      </div>
                      {errors.transactionType && (
                        <span
                          style={{ color: "red", fontSize: "0.8rem" }}
                          className="text-sm"
                        >
                          {errors.transactionType}
                        </span>
                      )}
                    </div>

                    {/* Construction Status */}
                    <div className="mb-4">
                      <label className="block mb-2 font-medium">
                        Construction Status *
                      </label>
                      <div className="button-group">
                        {["Ready to Move", "Under Construction"].map(
                          (status) => (
                            <button
                              key={status}
                              type="button"
                              className={`grid-item ${
                                constructionStatus === status ? "active" : ""
                              }`}
                              onClick={() => {
                                setConstructionStatus(status);
                                setErrors({
                                  ...errors,
                                  constructionStatus: "",
                                });
                              }}
                              required
                            >
                              {status}
                            </button>
                          )
                        )}
                      </div>
                      {errors.constructionStatus && (
                        <span
                          style={{ color: "red", fontSize: "0.8rem" }}
                          className="text-sm"
                        >
                          {errors.constructionStatus}
                        </span>
                      )}
                    </div>

                    {/* Bathroom Count */}
                    <div className="mb-4">
                      <label className="block mb-2 font-medium">
                        Bathroom *
                      </label>
                      <div className="button-group">
                        {[1, 2, 3, 4].map((num) => (
                          <button
                            key={num}
                            className={`grid-item ${
                              bathrooms === num ? "active" : ""
                            }`}
                            onClick={() => {
                              setBathrooms(num);
                              setErrors({ ...errors, bathrooms: "" });
                            }}
                            required
                          >
                            {num}
                          </button>
                        ))}
                      </div>
                      {errors.bathrooms && (
                        <span
                          style={{ color: "red", fontSize: "0.8rem" }}
                          className="text-sm"
                        >
                          {errors.bathrooms}
                        </span>
                      )}
                    </div>

                    {/* Balcony Count */}
                    <div className="mb-4">
                      <label className="block mb-2 font-medium">
                        Balcony *
                      </label>
                      <div className="button-group">
                        {[0, 1, 2, 3, 4].map((num) => (
                          <button
                            key={num}
                            className={`grid-item ${
                              balconies === num ? "active" : " "
                            }`}
                            onClick={() => {
                              setBalconies(num);
                              setErrors({ ...errors, balconies: "" });
                            }}
                            required
                          >
                            {num}
                          </button>
                        ))}
                      </div>
                      {errors.balconies && (
                        <span
                          style={{ color: "red", fontSize: "0.8rem" }}
                          className="text-sm"
                        >
                          {errors.balconies}
                        </span>
                      )}
                    </div>

                    {/* Furnish Type */}
                    <div className="mb-4">
                      <label className="block mb-2 font-medium">
                        Furnish Type *
                      </label>
                      <select
                        className="w-full p-2 border rounded-lg"
                        value={furnishType}
                        onChange={(e) => {
                          setFurnishType(e.target.value);
                          setErrors({ ...errors, furnishType });
                        }}
                        required
                      >
                        <option value="Unfurnished">Unfurnished</option>
                        <option value="Select Furnish Type">
                          Select Furnish Type
                        </option>
                        <option value="Fully Furnished">Fully Furnished</option>
                        <option value="Semi-Furnished">Semi-Furnished</option>
                      </select>
                      {errors.furnishType && (
                        <span
                          style={{ color: "red", fontSize: "0.8rem" }}
                          className="text-sm"
                        >
                          {errors.furnishType}
                        </span>
                      )}
                    </div>

                     {/* Age of Property */}
                     <div>
                        <label className="block mb-2 font-medium">
                          Age of Property
                        </label>
                        <input
                          type="number"
                          className="w-full p-2 border rounded-lg"
                          value={ageofproperty}
                          onChange={(e) => {
                            setAgeOfProperty(e.target.value);
                            setErrors({ ...errors, ageofproperty: "" });
                          }}
                          required
                        />
                        {errors.ageofproperty && (
                          <span
                            style={{ color: "red", fontSize: "0.8rem" }}
                            className="text-sm"
                          >
                            {errors.ageofproperty}
                          </span>
                        )}
                      </div>

                    {/* Parking Options */}
                    <div className="mb-4">
                      <label className="block mb-2 font-medium">
                        Covered Parking *
                      </label>
                      <div className="button-group">
                        {[0, 1, 2, 3, "3+"].map((num) => (
                          <button
                            key={num}
                            className={`grid-item ${
                              coveredParking === num ? "active" : " "
                            }`}
                            onClick={() => {
                              setCoveredParking(num);
                              setErrors({ ...errors, coveredParking });
                            }}
                            required
                          >
                            {num}
                          </button>
                        ))}
                      </div>
                      {errors.coveredParking && (
                        <span
                          style={{ color: "red", fontSize: "0.8rem" }}
                          className="text-sm"
                        >
                          {errors.coveredParking}
                        </span>
                      )}
                    </div>

                    <div className="mb-4">
                      <label className="block mb-2 font-medium">
                        Open Parking *
                      </label>
                      <div className="button-group">
                        {[0, 1, 2, 3, "3+"].map((num) => (
                          <button
                            key={num}
                            className={`grid-item ${
                              openParking === num ? "active" : " "
                            }`}
                            onClick={() => {
                              setOpenParking(num);
                              setErrors({ ...errors, openParking });
                            }}
                            required
                          >
                            {num}
                          </button>
                        ))}
                      </div>
                      {errors.openParking && (
                        <span
                          style={{ color: "red", fontSize: "0.8rem" }}
                          className="text-sm"
                        >
                          {errors.openParking}
                        </span>
                      )}
                    </div>

                    {/* Cost Input */}
                    <div className="mb-4">
                      <label className="block mb-2 font-medium">Cost *</label>
                      <input
                        type="text"
                        value={cost}
                        onChange={(e) => {
                          setCost(e.target.value);
                          setErrors({ ...errors, cost: "" });
                        }}
                        className="w-full p-2 border rounded-lg"
                        placeholder="Enter cost in INR"
                        required
                      />
                      {errors.cost && (
                        <span
                          style={{ color: "red", fontSize: "0.8rem" }}
                          className="text-sm"
                        >
                          {errors.cost}
                        </span>
                      )}
                    </div>

                    {/* Maintenance Charges */}
                    <div className="mb-4">
                      <label className="block mb-2 font-medium">
                        Maintenance Charges (per Sq.ft)
                      </label>
                      <input
                        type="number"
                        value={maintenanceCharges}
                        onChange={(e) => {
                          setMaintenanceCharges(e.target.value);
                          setErrors({ ...errors, maintenanceCharges: "" });
                        }}
                        required
                        className="w-full p-2 border rounded-lg"
                        placeholder="Enter maintenance charges"
                      />
                      {errors.maintenanceCharges && (
                        <span
                          style={{ color: "red", fontSize: "0.8rem" }}
                          className="text-sm"
                        >
                          {errors.maintenanceCharges}
                        </span>
                      )}
                    </div>

                    {/* Brokerage Question */}
                    <div className="mb-4">
                      <label className="block mb-2 font-medium">
                        Do you charge brokerage? *
                      </label>
                      <div className="button-group">
                        {["Yes", "No"].map((option) => (
                          <button
                            key={option}
                            className={`grid-item ${
                              brokerage === option ? "active" : ""
                            }`}
                            onClick={(e) => {
                              e.preventDefault(); // Prevent default form submit
                              setBrokerage(option); // Set brokerage value to 'Yes' or 'No'
                              setErrors({ ...errors, brokerage: "" }); // Reset error
                            }}
                          >
                            {option}
                          </button>
                        ))}
                        {errors.brokerage && (
                          <span style={{ color: "red", fontSize: "0.8rem" }}>
                            {errors.brokerage}
                          </span>
                        )}
                      </div>
                      {/* Brokerage Percentage Input - Only shows if "Yes" */}
                      {brokerage === "Yes" && (
                        <div>
                          <label>Brokerage Percentage</label>
                          <input
                            type="text"
                            value={bropercentage}
                            onChange={(e) => {
                              setBropercentage(e.target.value); // Update brokerage percentage
                              setErrors({ ...errors, bropercentage: "" }); // Reset error
                            }}
                          />
                          {errors.bropercentage && (
                            <span style={{ color: "red", fontSize: "0.8rem" }}>
                              {errors.bropercentage}
                            </span>
                          )}
                        </div>
                      )}
                    </div>

                    {/* Carpet Area */}
                    <div className="mb-4">
                      <label className="block mb-2 font-medium">
                        Carpet Area
                      </label>
                      <input
                        type="text"
                        value={carpetArea}
                        onChange={(e) => {
                          setCarpetArea(e.target.value);
                          setErrors({ ...errors, carpetArea: "" });
                        }}
                        required
                        className="w-full p-2 border rounded-lg"
                        placeholder="Enter area in sq. ft."
                      />
                      {errors.carpetArea && (
                        <span
                          style={{ color: "red", fontSize: "0.8rem" }}
                          className="text-sm"
                        >
                          {errors.carpetArea}
                        </span>
                      )}
                    </div>

                    {/* Floor Number and Total Floors */}
                    <div className="mb-4">
                      <label className="block mb-2 font-medium">
                        Floor No. *
                      </label>
                      <input
                        type="number"
                        value={floorNo}
                        onChange={(e) => {
                          setFloorNo(e.target.value);
                          setErrors({ ...errors, floorNo: "" });
                        }}
                        required
                        className="w-full p-2 border rounded-lg"
                        placeholder="Enter floor number"
                      />
                      {errors.floorNo && (
                        <span
                          style={{ color: "red", fontSize: "0.8rem" }}
                          className="text-sm"
                        >
                          {errors.floorNo}
                        </span>
                      )}
                    </div>

                    {/* Total Floors */}
                    <div className="mb-4">
                      <label className="block mb-2 font-medium">
                        Total Floors *
                      </label>
                      <input
                        type="number"
                        value={totalFloors}
                        onChange={(e) => {
                          setTotalFloors(e.target.value);
                          setErrors({ ...errors, totalFloors: "" });
                        }}
                        required
                        className="w-full p-2 border rounded-lg"
                        placeholder="Enter total floors in building"
                      />
                      {errors.totalFloors && (
                        <span
                          style={{ color: "red", fontSize: "0.8rem" }}
                          className="text-sm"
                        >
                          {errors.totalFloors}
                        </span>
                      )}
                    </div>

                    <div className="mb-4  rounded-lg p-4">
                      <button
                        className="font-medium text-purple-500"
                        onClick={() =>
                          setShowAdditionalDetails(!showAdditionalDetails)
                        }
                      >
                        {showAdditionalDetails
                          ? "Hide Additional Details ▲"
                          : "Add Additional Details ▼"}
                      </button>

                      {/* Additional Details Section */}
                      {showAdditionalDetails && (
                        <div>
                          <div className="mb-4">
                            <label className="block mb-2 font-medium">
                              Facing
                            </label>
                            <div className="grid grid-cols-3 gap-2">
                              {[
                                "North",
                                "East",
                                "West",
                                "South",
                                "North - East",
                                "North - West",
                                "South - East",
                                "South - West",
                              ].map((dir) => (
                                <button
                                  key={dir}
                                  className={`grid-item ${
                                    facing === dir ? "active" : " "
                                  }`}
                                  onClick={() => setFacing(dir)}
                                >
                                  {dir}
                                </button>
                              ))}
                            </div>
                          </div>

                          <div className="mb-4">
                            <label className="block mb-2 font-medium">
                              Servant Room
                            </label>
                            <div className="button-group">
                              {["Yes", "No"].map((option) => (
                                <button
                                  key={option}
                                  className={`grid-item ${
                                    servantRoom === option ? "active" : " "
                                  }`}
                                  onClick={() => setServantRoom(option)}
                                >
                                  {option}
                                </button>
                              ))}
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </>
                )}

                {(selectedPropertyType === "Plot" ||
                  selectedPropertyType === "Agricultural") && (
                  <div>
                    {/* Transaction Type */}
                    <div className="mb-4">
                      <label className="block mb-2 font-medium">
                        Transaction Type *
                      </label>
                      <div className="button-group">
                        {["New Booking", "Resale"].map((type) => (
                          <button
                            key={type}
                            className={`grid-item ${
                              transactionType === type ? "active" : " "
                            }`}
                            onClick={() => {
                              setTransactionType(type);
                              setErrors({ ...errors, transactionType: "" });
                            }}
                            required
                          >
                            {type}
                          </button>
                        ))}
                      </div>
                      {errors.transactionType && (
                        <span
                          style={{ color: "red", fontSize: "0.8rem" }}
                          className="text-sm"
                        >
                          {errors.transactionType}
                        </span>
                      )}
                    </div>

                    {/* Possession Status */}
                    <div className="mb-4">
                      <label className="block mb-2 font-medium">
                        Possession Status *
                      </label>
                      <div className="button-group">
                        {["Immediate", "In Future"].map((status) => (
                          <button
                            key={status}
                            className={`grid-item ${
                              posessionStatus === status ? "active" : " "
                            }`}
                            onClick={() => {
                              setPosessionStatus(status);
                              setErrors({ ...errors, posessionStatus: "" });
                            }}
                            required
                          >
                            {status}
                          </button>
                        ))}
                      </div>
                      {errors.posessionStatus && (
                        <span
                          style={{ color: "red", fontSize: "0.8rem" }}
                          className="text-sm"
                        >
                          {errors.posessionStatus}
                        </span>
                      )}
                    </div>

                    {posessionStatus === "Immediate" && (
                      <div>
                        <label className="block mb-2 font-medium">
                          Age of Property
                        </label>
                        <input
                          type="number"
                          className="w-full p-2 border rounded-lg"
                          value={ageofproperty}
                          onChange={(e) => {
                            setAgeOfProperty(e.target.value);
                            setErrors({ ...errors, ageofproperty: "" });
                          }}
                          required
                        />
                        {errors.ageofproperty && (
                          <span
                            style={{ color: "red", fontSize: "0.8rem" }}
                            className="text-sm"
                          >
                            {errors.ageofproperty}
                          </span>
                        )}
                        <label className="block mb-2 font-medium">
                          Plot Price*
                        </label>
                        <input
                          type="number"
                          className="w-full p-2 border rounded-lg"
                          value={plotprice}
                          onChange={(e) => {
                            setPlotPrice(e.target.value);
                            setErrors({ ...errors, plotprice: "" });
                          }}
                          required
                        />
                        {errors.plotprice && (
                          <span
                            style={{ color: "red", fontSize: "0.8rem" }}
                            className="text-sm"
                          >
                            {errors.plotprice}
                          </span>
                        )}
                      </div>
                    )}

                    {posessionStatus === "In Future" && (
                      <div>
                        <label className="block mb-2 font-medium">
                          Possesion Date
                        </label>
                        <input
                          type="date"
                          className="w-full p-2 border rounded-lg"
                          value={possessiondate}
                          onChange={(e) => {
                            setPossessionDate(e.target.value);
                            setErrors({ ...errors, possessiondate });
                          }}
                          required
                        />
                        {errors.possessiondate && (
                          <span
                            style={{ color: "red", fontSize: "0.8rem" }}
                            className="text-sm"
                          >
                            {errors.possessiondate}
                          </span>
                        )}

                        <label className="block mb-2 font-medium">
                          Plot Price*
                        </label>
                        <input
                          type="number"
                          className="w-full p-2 border rounded-lg"
                          value={plotprice}
                          onChange={(e) => {
                            setPlotPrice(e.target.value);
                            setErrors({ ...errors, plotprice: "" });
                          }}
                          required
                        />
                        {errors.plotprice && (
                          <span
                            style={{ color: "red", fontSize: "0.8rem" }}
                            className="text-sm"
                          >
                            {errors.plotprice}
                          </span>
                        )}
                      </div>
                    )}

                    {/* Maintenance Charges */}
                    <div className="mb-4">
                      <label className="block mb-2 font-medium">
                        Maintenance Charges (per Sq.ft)
                      </label>
                      <input
                        type="number"
                        value={maintenanceCharges}
                        onChange={(e) => {
                          setMaintenanceCharges(e.target.value);
                          setErrors({ ...errors, maintenanceCharges: "" });
                        }}
                        required
                        className="w-full p-2 border rounded-lg"
                        placeholder="Enter maintenance charges"
                      />
                      {errors.maintenanceCharges && (
                        <span
                          style={{ color: "red", fontSize: "0.8rem" }}
                          className="text-sm"
                        >
                          {errors.maintenanceCharges}
                        </span>
                      )}
                    </div>

                    {/* Brokerage Question */}
                    <div className="mb-4">
                      <label className="block mb-2 font-medium">
                        Do you charge brokerage? *
                      </label>
                      <div className="button-group">
                        {["Yes", "No"].map((option) => (
                          <button
                            key={option}
                            className={`grid-item ${
                              brokerage === option ? "active" : ""
                            }`}
                            onClick={(e) => {
                              e.preventDefault(); // Prevent default form submit
                              setBrokerage(option); // Set brokerage value to 'Yes' or 'No'
                              setErrors({ ...errors, brokerage: "" }); // Reset error
                            }}
                          >
                            {option}
                          </button>
                        ))}
                        {errors.brokerage && (
                          <span style={{ color: "red", fontSize: "0.8rem" }}>
                            {errors.brokerage}
                          </span>
                        )}
                      </div>
                      {/* Brokerage Percentage Input - Only shows if "Yes" */}
                      {brokerage === "Yes" && (
                        <div>
                          <label>Brokerage Percentage</label>
                          <input
                            type="text"
                            value={bropercentage}
                            onChange={(e) => {
                              setBropercentage(e.target.value); // Update brokerage percentage
                              setErrors({ ...errors, bropercentage: "" }); // Reset error
                            }}
                          />
                          {errors.bropercentage && (
                            <span style={{ color: "red", fontSize: "0.8rem" }}>
                              {errors.bropercentage}
                            </span>
                          )}
                        </div>
                      )}
                    </div>

                    {/* Plot Area & Dimensions */}
                    <div className="mb-4 grid grid-cols-2 gap-4">
                      <div>
                        <label className="block mb-2 font-medium">
                          Plot Area *
                        </label>
                        <input
                          type="number"
                          value={plotArea}
                          onChange={(e) => {
                            setPlotArea(e.target.value);
                            setErrors({ ...errors, plotArea: "" });
                          }}
                          required
                          className="w-full p-2 border rounded-lg"
                          placeholder="Enter plot area"
                        />
                        {errors.plotArea && (
                          <span
                            style={{ color: "red", fontSize: "0.8rem" }}
                            className="text-sm"
                          >
                            {errors.plotArea}
                          </span>
                        )}
                      </div>

                      <div>
                        <label className="block mb-2 font-medium">
                          Select Area Unit *
                        </label>
                        <select
                          value={areaUnit}
                          onChange={(e) => {
                            setAreaUnit(e.target.value);
                            setErrors({ ...errors, areaUnit: "" });
                          }}
                          required
                          className="w-full p-2 border rounded-lg"
                        >
                          <option value="">Select unit</option>
                          <option value="sq ft">Sq. Ft.</option>
                          <option value="sq m">Sq. M.</option>
                          <option value="acres">Acres</option>
                        </select>
                        {errors.areaUnit && (
                          <span
                            style={{ color: "red", fontSize: "0.8rem" }}
                            className="text-sm"
                          >
                            {errors.areaUnit}
                          </span>
                        )}
                      </div>
                    </div>

                    {/* Length & Width */}
                    <div className="mb-4 grid grid-cols-2 gap-4">
                      <div>
                        <label className="block mb-2 font-medium">
                          Length *
                        </label>
                        <input
                          type="number"
                          value={length}
                          onChange={(e) => {
                            setLength(e.target.value);
                            setErrors({ ...errors, length: "" });
                          }}
                          required
                          className="w-full p-2 border rounded-lg"
                          placeholder="Enter length"
                        />
                        {errors.length && (
                          <span
                            style={{ color: "red", fontSize: "0.8rem" }}
                            className="text-sm"
                          >
                            {errors.length}
                          </span>
                        )}
                      </div>
                      <div>
                        <label className="block mb-2 font-medium">
                          Width *
                        </label>
                        <input
                          type="number"
                          value={width}
                          onChange={(e) => {
                            setWidth(e.target.value);
                            setErrors({ ...errors, width: "" });
                          }}
                          required
                          className="w-full p-2 border rounded-lg"
                          placeholder="Enter width"
                        />
                        {errors.width && (
                          <span
                            style={{ color: "red", fontSize: "0.8rem" }}
                            className="text-sm"
                          >
                            {errors.width}
                          </span>
                        )}
                      </div>
                    </div>

                    {/* Width of Facing Road */}
                    <div className="mb-4">
                      <label className="block mb-2 font-medium">
                        Width of Facing Road *
                      </label>
                      <input
                        type="text"
                        value={facingRoadWidth}
                        onChange={(e) => {
                          setFacingRoadWidth(e.target.value);
                          setErrors({ ...errors, facingRoadWidth: "" });
                        }}
                        required
                        className="w-full p-2 border rounded-lg"
                        placeholder="Enter facing road width"
                      />
                      {errors.facingRoadWidth && (
                        <span
                          style={{ color: "red", fontSize: "0.8rem" }}
                          className="text-sm"
                        >
                          {errors.facingRoadWidth}
                        </span>
                      )}
                    </div>

                    {/* Additional Details */}
                    <div className="mb-4 border rounded-lg p-4">
                      {/* Toggle Button */}
                      <button
                        className="font-medium text-purple-500"
                        onClick={() =>
                          setShowAdditionalDetails(!showAdditionalDetails)
                        }
                      >
                        {showAdditionalDetails
                          ? "Hide Additional Details ▲"
                          : "Add Additional Details ▼"}
                      </button>

                      {/* Additional Details Section */}
                      {showAdditionalDetails && (
                        <div className="mt-4">
                          {/* Corner Property */}
                          <div className="mb-4">
                            <label className="block mb-2 font-medium">
                              Corner Property?
                            </label>
                            <div className="button-group">
                              {["Yes", "No"].map((option) => (
                                <button
                                  key={option}
                                  className={`grid-item ${
                                    cornerProperty === option ? "active" : " "
                                  }`}
                                  onClick={() => setCornerProperty(option)}
                                >
                                  {option}
                                </button>
                              ))}
                            </div>
                          </div>

                          {/* Construction Started */}
                          <div className="mb-4">
                            <label className="block mb-2 font-medium">
                              Construction Started?
                            </label>
                            <div className="button-group">
                              {["Yes", "No"].map((option) => (
                                <button
                                  key={option}
                                  className={`grid-item ${
                                    constructionStarted === option
                                      ? "active"
                                      : " "
                                  }`}
                                  onClick={() => setConstructionStarted(option)}
                                >
                                  {option}
                                </button>
                              ))}
                            </div>
                          </div>

                          {/* Facing Direction */}
                          <div className="mb-4">
                            <label className="block mb-2 font-medium">
                              Facing
                            </label>
                            <div className="button-group flex-wrap">
                              {[
                                "North",
                                "East",
                                "West",
                                "South",
                                "North-East",
                              ].map((direction) => (
                                <button
                                  key={direction}
                                  className={`grid-item ${
                                    facingDirection === direction
                                      ? "active"
                                      : " "
                                  }`}
                                  onClick={() => setFacingDirection(direction)}
                                >
                                  {direction}
                                </button>
                              ))}
                            </div>
                          </div>

                          {/* Address Section */}
                          <div className="border-t mt-6 pt-4">
                            {/* Boundary Wall Present */}
                            <div className="mb-4">
                              <label className="block mb-2 font-medium">
                                Boundary Wall Present?
                              </label>
                              <div className="button-group">
                                {["Yes", "No"].map((option) => (
                                  <button
                                    key={option}
                                    className={`grid-item ${
                                      boundaryWall === option ? "active" : " "
                                    }`}
                                    onClick={() => setBoundaryWall(option)}
                                  >
                                    {option}
                                  </button>
                                ))}
                              </div>
                            </div>

                            {/* Number of Open Sides */}
                            <div className="mb-4">
                              <label className="block mb-2 font-medium">
                                No. of Open Sides
                              </label>
                              <div className="button-group">
                                {[1, 2, 3, 4, "4+"].map((side) => (
                                  <button
                                    key={side}
                                    className={`grid-item ${
                                      openSides === side ? "active" : " "
                                    }`}
                                    onClick={() => setOpenSides(side)}
                                  >
                                    {side}
                                  </button>
                                ))}
                              </div>
                            </div>

                            {/* Floors Allowed for Construction */}
                            <div className="mb-4">
                              <label className="block mb-2 font-medium">
                                Floors Allowed for Construction
                              </label>
                              <input
                                type="text"
                                value={floorsAllowed}
                                onChange={(e) =>
                                  setFloorsAllowed(e.target.value)
                                }
                                className="w-full p-2 border rounded-lg"
                                placeholder="Enter allowed floors"
                              />
                            </div>

                            {/* RERA ID */}
                            <div className="mb-4">
                              <label className="block mb-2 font-medium">
                                RERA ID
                              </label>
                              <input
                                type="text"
                                value={reraId}
                                onChange={(e) => setReraId(e.target.value)}
                                className="w-full p-2 border rounded-lg"
                                placeholder="Enter RERA ID"
                              />
                            </div>

                            {/* Property Description */}
                            <div className="mb-4">
                              <label className="block mb-2 font-medium">
                                Property Description
                              </label>
                              <textarea
                                value={propertyDescription}
                                onChange={(e) =>
                                  setPropertyDescription(e.target.value)
                                }
                                className="w-full p-2 border rounded-lg"
                                placeholder="Enter property details"
                                maxLength={1500}
                              />
                              <p className="text-right text-sm text-gray-500">
                                {propertyDescription.length} / 1500
                              </p>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                )}

                {(selectedPropertyType === "Independent Floor" ||
                  selectedPropertyType === "Independent House" ||
                  selectedPropertyType === "Villa" ||
                  selectedPropertyType === "Penthouse" ||
                  selectedPropertyType === "Duplex" ||
                  selectedPropertyType === "Studio") && (
                  <div>
                    {/* BHK Selection */}
                    <div className="mb-4">
                      <label className="block mb-2 font-medium">BHK *</label>
                      <div className="button-group bhkwidth">
                        {bhkOptions.map((status) => (
                          <button
                            key={status}
                            className={`grid-item ${
                              bhkType === status ? "active" : " "
                            }`}
                            onClick={() => {
                              setBhkType(status);
                              setErrors({ ...errors, bhkType: "" });
                            }}
                          >
                            {status}
                          </button>
                        ))}
                      </div>
                      {errors.bhkType && (
                        <span
                          style={{ color: "red", fontSize: "0.8rem" }}
                          className="text-sm"
                        >
                          {errors.bhkType}
                        </span>
                      )}
                    </div>
                    {/* Built-Up Area */}
                    <div className="mb-4">
                      <label className="block mb-2 font-medium">
                        Built Up Area *
                      </label>
                      <input
                        type="text"
                        value={builtUpArea}
                        onChange={(e) => {
                          setBuiltUpArea(e.target.value);
                          setErrors({ ...errors, builtUpArea: "" });
                        }}
                        required
                        className="w-full p-2 border rounded-lg"
                        placeholder="Enter built-up area in sq. ft."
                      />
                      {errors.builtUpArea && (
                        <span
                          style={{ color: "red", fontSize: "0.8rem" }}
                          className="text-sm"
                        >
                          {errors.builtUpArea}
                        </span>
                      )}
                    </div>

                     {/* Land Area */}
                    <div className="mb-4">
                      <label className="block mb-2 font-medium">
                        Land Area
                      </label>
                      <input
                        type="number"
                        value={landArea}
                        onChange={(e) => {
                          setLandArea(e.target.value);
                          setErrors({ ...errors, landArea });
                        }}
                        className="w-full p-2 border rounded-lg"
                        placeholder="Enter Land area in sq. ft."
                      />
                      {errors.landArea && (
                        <span
                          style={{ color: "red", fontSize: "0.8rem" }}
                          className="text-sm"
                        >
                          {errors.landArea}
                        </span>
                      )}
                    </div>

                    <div className="mb-4">
                      <label className="block mb-2 font-medium">
                        UDS Land
                      </label>
                      <div className="button-group">
                        {["Yes", "No"].map((option) => (
                          <button
                            key={option}
                            className={`grid-item ${
                              uds === option ? "active" : ""
                            }`}
                            onClick={(e) => {
                              e.preventDefault(); // Prevent default form submit
                              setUds(option); // Set brokerage value to 'Yes' or 'No'
                              setErrors({ ...errors, uds: "" }); // Reset error
                            }}
                          >
                            {option}
                          </button>
                        ))}
                        {errors.uds && (
                          <span style={{ color: "red", fontSize: "0.8rem" }}>
                            {errors.uds}
                          </span>
                        )}
                      </div>
                      </div>

                    {/* Transaction Type */}
                    <div className="mb-4">
                      <label className="block mb-2 font-medium">
                        Transaction Type *
                      </label>
                      <div className="button-group">
                        {["New Booking", "Resale"].map((type) => (
                          <button
                            key={type}
                            type="button"
                            className={`grid-item ${
                              transactionType === type ? "active" : " "
                            }`}
                            onClick={(e) => {
                              e.preventDefault();
                              setTransactionType(type);
                              setErrors({ ...errors, transactionType });
                            }}
                            required
                          >
                            {type}
                          </button>
                        ))}
                      </div>
                      {errors.transactionType && (
                        <span
                          style={{ color: "red", fontSize: "0.8rem" }}
                          className="text-sm"
                        >
                          {errors.transactionType}
                        </span>
                      )}
                    </div>

                    {/* Construction Status */}
                    <div className="mb-4">
                      <label className="block mb-2 font-medium">
                        Construction Status *
                      </label>
                      <div className="button-group">
                        {["Ready to Move", "Under Construction"].map(
                          (status) => (
                            <button
                              key={status}
                              type="button"
                              className={`grid-item ${
                                constructionStatus === status ? "active" : " "
                              }`}
                              onClick={(e) => {
                                e.preventDefault();
                                setConstructionStatus(status);
                                setErrors((prev) => ({
                                  ...prev,
                                  constructionStatus: "",
                                }));
                              }}
                              required
                            >
                              {status}
                            </button>
                          )
                        )}
                      </div>
                      {errors.constructionStatus && (
                        <span
                          style={{ color: "red", fontSize: "0.8rem" }}
                          className="text-sm"
                        >
                          {errors.constructionStatus}
                        </span>
                      )}
                    </div>

                    {/* Bathroom Count */}
                    <div className="mb-4">
                      <label className="block mb-2 font-medium">
                        Bathroom *
                      </label>
                      <div className="button-group">
                        {[1, 2, 3, 4].map((num) => (
                          <button
                            key={num}
                            type="button"
                            className={`grid-item ${
                              bathrooms === num ? "active" : ""
                            }`}
                            onClick={() => {
                              setBathrooms(num);
                              setErrors({ ...errors, bathrooms });
                            }}
                            required
                          >
                            {num}
                          </button>
                        ))}
                      </div>
                      {errors.bathrooms && (
                        <span
                          style={{ color: "red", fontSize: "0.8rem" }}
                          className="text-sm"
                        >
                          {errors.bathrooms}
                        </span>
                      )}
                    </div>

                    {/* Balcony Count */}
                    <div className="mb-4">
                      <label className="block mb-2 font-medium">
                        Balcony *
                      </label>
                      <div className="button-group">
                        {[0, 1, 2, 3, 4].map((status) => (
                          <button
                            key={status}
                            className={`grid-item ${
                              balconies === status ? "active" : " "
                            }`}
                            onClick={() => {
                              setBalconies(status);
                              setErrors({ ...errors, balconies: "" });
                            }}
                            required
                          >
                            {status}
                          </button>
                        ))}
                      </div>
                      {errors.balconies && (
                        <span
                          style={{ color: "red", fontSize: "0.8rem" }}
                          className="text-sm"
                        >
                          {errors.balconies}
                        </span>
                      )}
                    </div>

                    {/* Furnish Type */}
                    <div className="mb-4">
                      <label className="block mb-2 font-medium">
                        Furnish Type *
                      </label>
                      <select
                        className="w-full p-2 border rounded-lg"
                        value={furnishType}
                        onChange={(e) => {
                          setFurnishType(e.target.value);
                          setErrors({ ...errors, furnishType });
                        }}
                        required
                      >
                        <option>Select Furnish Type</option>
                        <option value="Unfurnished">Unfurnished</option>
                        <option value="Fully Furnished">Fully Furnished</option>
                        <option value="Semi-Furnished">Semi-Furnished</option>
                      </select>
                      {errors.furnishType && (
                        <span
                          style={{ color: "red", fontSize: "0.8rem" }}
                          className="text-sm"
                        >
                          {errors.furnishType}
                        </span>
                      )}
                    </div>

                    {/* Parking Options */}
                    <div className="mb-4">
                      <label className="block mb-2 font-medium">
                        Covered Parking *
                      </label>
                      <div className="button-group">
                        {[0, 1, 2, 3, "3+"].map((num) => (
                          <button
                            key={num}
                            className={`grid-item ${
                              coveredParking === num ? "active" : " "
                            }`}
                            onClick={() => {
                              setCoveredParking(num);
                              setErrors({ ...errors, coveredParking });
                            }}
                            required
                          >
                            {num}
                          </button>
                        ))}
                      </div>
                      {errors.coveredParking && (
                        <span
                          style={{ color: "red", fontSize: "0.8rem" }}
                          className="text-sm"
                        >
                          {errors.coveredParking}
                        </span>
                      )}
                    </div>

                    <div className="mb-4">
                      <label className="block mb-2 font-medium">
                        Open Parking *
                      </label>
                      <div className="button-group">
                        {[0, 1, 2, 3, "3+"].map((num) => (
                          <button
                            key={num}
                            className={`grid-item ${
                              openParking === num ? "active" : " "
                            }`}
                            onClick={() => {
                              setOpenParking(num);
                              setErrors({ ...errors, openParking });
                            }}
                            required
                          >
                            {num}
                          </button>
                        ))}
                      </div>
                      {errors.openParking && (
                        <span
                          style={{ color: "red", fontSize: "0.8rem" }}
                          className="text-sm"
                        >
                          {errors.openParking}
                        </span>
                      )}
                    </div>

                    {/* Cost Input */}
                    <div className="mb-4">
                      <label className="block mb-2 font-medium">Cost *</label>
                      <input
                        type="text"
                        value={cost}
                        onChange={(e) => {
                          setCost(e.target.value);
                          setErrors({ ...errors, cost: "" });
                        }}
                        className="w-full p-2 border rounded-lg"
                        placeholder="Enter cost in INR"
                        required
                      />
                      {errors.cost && (
                        <span
                          style={{ color: "red", fontSize: "0.8rem" }}
                          className="text-sm"
                        >
                          {errors.cost}
                        </span>
                      )}
                    </div>

                    {/* Maintenance Charges */}
                    <div className="mb-4">
                      <label className="block mb-2 font-medium">
                        Maintenance Charges (per Sq.ft)
                      </label>
                      <input
                        type="number"
                        value={maintenanceCharges}
                        onChange={(e) => {
                          setMaintenanceCharges(e.target.value);
                          setErrors({ ...errors, maintenanceCharges });
                        }}
                        required
                        className="w-full p-2 border rounded-lg"
                        placeholder="Enter maintenance charges"
                      />
                      {errors.maintenanceCharges && (
                        <span
                          style={{ color: "red", fontSize: "0.8rem" }}
                          className="text-sm"
                        >
                          {errors.maintenanceCharges}
                        </span>
                      )}
                    </div>

                    {/* Age of Property */}
                    <div>
                        <label className="block mb-2 font-medium">
                          Age of Property
                        </label>
                        <input
                          type="number"
                          className="w-full p-2 border rounded-lg"
                          value={ageofproperty}
                          onChange={(e) => {
                            setAgeOfProperty(e.target.value);
                            setErrors({ ...errors, ageofproperty: "" });
                          }}
                          required
                        />
                        {errors.ageofproperty && (
                          <span
                            style={{ color: "red", fontSize: "0.8rem" }}
                            className="text-sm"
                          >
                            {errors.ageofproperty}
                          </span>
                        )}
                      </div>

                    {/* Brokerage Question */}
                    <div className="mb-4">
                      <label className="block mb-2 font-medium">
                        Do you charge brokerage? *
                      </label>
                      <div className="button-group">
                        {["Yes", "No"].map((option) => (
                          <button
                            key={option}
                            className={`grid-item ${
                              brokerage === option ? "active" : ""
                            }`}
                            onClick={(e) => {
                              e.preventDefault(); // Prevent default form submit
                              setBrokerage(option); // Set brokerage value to 'Yes' or 'No'
                              setErrors({ ...errors, brokerage: "" }); // Reset error
                            }}
                          >
                            {option}
                          </button>
                        ))}
                        {errors.brokerage && (
                          <span style={{ color: "red", fontSize: "0.8rem" }}>
                            {errors.brokerage}
                          </span>
                        )}
                      </div>
                      {/* Brokerage Percentage Input - Only shows if "Yes" */}
                      {brokerage === "Yes" && (
                        <div>
                          <label>Brokerage Percentage</label>
                          <input
                            type="text"
                            value={bropercentage}
                            onChange={(e) => {
                              setBropercentage(e.target.value); // Update brokerage percentage
                              setErrors({ ...errors, bropercentage: "" }); // Reset error
                            }}
                          />
                          {errors.bropercentage && (
                            <span style={{ color: "red", fontSize: "0.8rem" }}>
                              {errors.bropercentage}
                            </span>
                          )}
                        </div>
                      )}
                    </div>

                    {/* Carpet Area */}
                    <div className="mb-4">
                      <label className="block mb-2 font-medium">
                        Carpet Area
                      </label>
                      <input
                        type="number"
                        value={carpetArea}
                        onChange={(e) => {
                          setCarpetArea(e.target.value);
                          setErrors({ ...errors, carpetArea });
                        }}
                       
                        className="w-full p-2 border rounded-lg"
                        placeholder="Enter area in sq. ft."
                      />
                      {errors.carpetArea && (
                        <span
                          style={{ color: "red", fontSize: "0.8rem" }}
                          className="text-sm"
                        >
                          {errors.carpetArea}
                        </span>
                      )}
                    </div>

                    {/* Floor Number and Total Floors */}
                    <div className="mb-4">
                      <label className="block mb-2 font-medium">
                        Floor No. *
                      </label>
                      <input
                        type="number"
                        value={floorNo}
                        onChange={(e) => {
                          setFloorNo(e.target.value);
                          setErrors({ ...errors, floorNo });
                        }}
                        required
                        className="w-full p-2 border rounded-lg"
                        placeholder="Enter floor number"
                      />
                      {errors.floorNo && (
                        <span
                          style={{ color: "red", fontSize: "0.8rem" }}
                          className="text-sm"
                        >
                          {errors.floorNo}
                        </span>
                      )}
                    </div>

                    {/* Total Floors */}
                    <div className="mb-4">
                      <label className="block mb-2 font-medium">
                        Total Floors *
                      </label>
                      <input
                        type="text"
                        value={totalFloors}
                        onChange={(e) => {
                          setTotalFloors(e.target.value);
                          setErrors({ ...errors, totalFloors });
                        }}
                        required
                        className="w-full p-2 border rounded-lg"
                        placeholder="Enter total floors in building"
                      />
                      {errors.totalFloors && (
                        <span
                          style={{ color: "red", fontSize: "0.8rem" }}
                          className="text-sm"
                        >
                          {errors.totalFloors}
                        </span>
                      )}
                    </div>

                    <div className="additional">
                      <button
                        className="addbtn"
                        onClick={() =>
                          setShowAdditionalDetails(!showAdditionalDetails)
                        }
                      >
                        {showAdditionalDetails
                          ? "Hide Additional Details ▲"
                          : "Add Additional Details ▼"}
                      </button>

                      {/* Additional Details Section */}
                      {showAdditionalDetails && (
                        <div>
                          <div className="mb-4">
                            <label className="block mb-2 font-medium">
                              Facing
                            </label>
                            <div className="button-group">
                              {[
                                "North",
                                "East",
                                "West",
                                "South",
                                "North - East",
                                "North - West",
                                "South - East",
                                "South - West",
                              ].map((dir) => (
                                <button
                                  key={dir}
                                  className={`grid-item ${
                                    facing === dir ? "active" : " "
                                  }`}
                                  onClick={() => setFacing(dir)}
                                >
                                  {dir}
                                </button>
                              ))}
                            </div>
                          </div>

                          <div className="mb-4">
                            <label className="block mb-2 font-medium">
                              Servant Room
                            </label>
                            <div className="button-group">
                              {["Yes", "No"].map((option) => (
                                <button
                                  key={option}
                                  className={`grid-item ${
                                    servantRoom === option ? "active" : " "
                                  }`}
                                  onClick={() => setServantRoom(option)}
                                >
                                  {option}
                                </button>
                              ))}
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                )}

                {/* Next Button
                        <button onClick={() => setStep(2)} className="next-button">
                            Next, add amenities details
                        </button> */}
              </div>
            )}

            {currentStep === 2 && (
              <div>
                <h2 className="text-xl font-semibold mb-4">
                  Add Furnishings and Amenities
                </h2>

                {/* Flat Furnishings */}
                <h3 className="text-lg font-medium mb-2">Flat Furnishings</h3>
                <div className="button-group mb-4">
                  {furnishings.map((item) => (
                    <button
                      key={item}
                      className={`grid-item ${
                        selectedFurnishings.includes(item) ? "active" : " "
                      }`}
                      onClick={() =>
                        toggleSelection(
                          item,
                          selectedFurnishings,
                          setSelectedFurnishings
                        )
                      }
                    >
                      {item}
                    </button>
                  ))}
                </div>

                {/* Society Amenities */}
                <h3 className="text-lg font-medium mb-2">Society Amenities</h3>
                <div className="button-group mb-4">
                  {amenities.map((item) => (
                    <button
                      key={item}
                      className={`grid-item ${
                        selectedAmenities.includes(item) ? "active" : " "
                      }`}
                      onClick={() =>
                        toggleSelection(
                          item,
                          selectedAmenities,
                          setSelectedAmenities
                        )
                      }
                    >
                      {item}
                    </button>
                  ))}
                </div>
                {/* Image Upload Section */}
                <div className="container-img">
                  <label className="title">Upload Property Media</label>

                  <div className="upload-section">
                    <label className="upload-label">Upload Images</label>
                    <input
                      type="file"
                      accept="image/*"
                      multiple
                      onChange={handleImageUpload}
                    />
                    <div className="preview-container">
                      {images.map((image, index) => {
                        let imageUrl = "";

                        if (typeof image === "string") {
                          // Direct URL from DB
                          imageUrl = image;
                        } else if (image instanceof File) {
                          // File uploaded by user
                          imageUrl = URL.createObjectURL(image);
                        } else {
                          console.error("Invalid file data:", image);
                          return null;
                        }

                        return (
                          <div key={index} className="preview-item">
                            <img src={imageUrl} alt="Uploaded" />
                            <button
                              onClick={() => removeImage(index)}
                              className="remove-btn"
                            >
                              ✕
                            </button>
                          </div>
                        );
                      })}
                    </div>
                  </div>

                  {/* Video Upload Section */}
                  <div className="upload-section">
                    <label className="upload-label">Upload Videos</label>
                    <input
                      type="file"
                      accept="video/*"
                      multiple
                      onChange={handleVideoUpload}
                    />
                    <div className="preview-container">
                      {videos.map((video, index) => (
                        <div key={index} className="preview-item">
                          <video controls className="preview-video">
                            <source
                              src={URL.createObjectURL(video)}
                              type="video/mp4"
                            />
                          </video>
                          <button
                            onClick={() => removeVideo(index)}
                            className="remove-btn"
                          >
                            ✕
                          </button>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>

                {/* <button onClick={() => setStep(1)} className="next-button">
                            Back
                        </button>
                        <button onClick={() => setStep(3)} className="next-button">
                            Next, add address details
                        </button> */}
              </div>
            )}

            {currentStep === 3 && (
              <div>
                <h2 className="text-lg font-semibold">Add Address</h2>
                <p className="text-gray-600">Locality / Sector *</p>
                <input
                  type="text"
                  className="w-full border rounded-lg p-2 my-2"
                  value={selectedLocality}
                  onChange={(e) => setLocality(e.target.value)}
                  placeholder="Enter location of the property.."
                />

                <h3 className="text-md font-medium mt-4">
                  Where is your property located?
                </h3>
                <p className="text-sm text-gray-500">
                  Search for a location or click on the map to select manually.
                </p>

                <div className="mapcontainer">
                  <MapContainer
                    center={position}
                    zoom={14}
                    style={{
                      height: "400px",
                      width: "100%",
                      alignItems: "center",
                    }}
                  >
                    <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
                    <Marker position={position} icon={customIcon}>
                      <Popup>
                        {paraaddress || "Click on the map to select location"}
                      </Popup>
                    </Marker>
                    <LocationSelector
                      setPosition={setPosition}
                      setAddress={setAddress}
                    />
                  </MapContainer>
                </div>

                <p className="mt-2 text-gray-700 md-6">
                  <strong>Selected Address:</strong> {Address}
                </p>

                {/* <button  className="next-button"  onClick={handleSubmit}>
                                Post Property
                              </button> */}
              </div>
            )}

            <div className="button-group">
              {currentStep > 1 && (
                <button onClick={handlePrevStep} className="button prev">
                  Back
                </button>
              )}
              {currentStep < steps.length ? (
                <button
                  onClick={() => {
                    if (handleNextStep()) {
                      handleNextStep();
                    } else {
                      // Find the first error field and scroll to it
                      const firstErrorKey = Object.keys(errors).find(
                        (key) => errors[key]
                      );
                      if (firstErrorKey) {
                        const errorRef = getRefByKey(firstErrorKey);
                        if (errorRef && errorRef.current) {
                          errorRef.current.scrollIntoView({
                            behavior: "smooth",
                            block: "start",
                          });
                        }
                      }
                    }
                  }}
                  className="button next"
                >
                  Next
                </button>
              ) : (
                <button onClick={handleSubmit} className="button next">
                  Submit
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddPropertyResidentialResell;
